// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarChatHistoryList_container__6GuGg {
    /* width: 246px; */
    width: 100%;
}

.SideBarChatHistoryList_expert_butn_box__8hCwE {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 200px;
    height: 100%;
    cursor: pointer;
}

.SideBarChatHistoryList_item_title__EglRC {
    width: 100%;
    padding-left: 10px;
    color: #e7e7e7;
    font-family: 'PingFangSCRegular', sans-serif;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.SideBarChatHistoryList_shrink_img__i\\+0cK {
    width: 11px;
    height: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarChatHistoryList/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf","sourcesContent":[".container {\n    /* width: 246px; */\n    width: 100%;\n}\n\n.expert_butn_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 200px;\n    height: 100%;\n    cursor: pointer;\n}\n\n.item_title {\n    width: 100%;\n    padding-left: 10px;\n    color: #e7e7e7;\n    font-family: 'PingFangSCRegular', sans-serif;\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.shrink_img {\n    width: 11px;\n    height: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideBarChatHistoryList_container__6GuGg`,
	"expert_butn_box": `SideBarChatHistoryList_expert_butn_box__8hCwE`,
	"item_title": `SideBarChatHistoryList_item_title__EglRC`,
	"shrink_img": `SideBarChatHistoryList_shrink_img__i+0cK`
};
export default ___CSS_LOADER_EXPORT___;
